
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/partners",
      function () {
        return require("private-next-pages/qmee/partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/partners"])
      });
    }
  